require('../modules/es7.array.includes');
module.exports = require('../modules/_core').Array;


//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/digicerba-modules/digicerba-formulaire-demat/digicerba-formulaire-demat-web/src/angular/cerba/~/core-js/es7/array.js
// module id = ../../../../core-js/es7/array.js
// module chunks = 1